<template>
  
  <!-- Marker -->
  <div
    class       = "marker"
    :class      = "type"
    :style      = "markerStyle"
    @mouseenter = "$emit('enter');"
    @mouseleave = "$emit('leave');"
  >
  </div>

</template>

<script>

// #region Constants

const MARKER_WIDTH_PX   = 6;
const MARKER_HEIGHT_PX  = 6;

// #endregion Constants

export default {

  // #region Properties

  name:  'ScrubBarMarker',
  props: {
    color: String,
    type:  String
  },
  computed: {
    markerStyle() {
      return {
        'width':         `${MARKER_WIDTH_PX}px`,
        'height':        `${MARKER_HEIGHT_PX}px`,
        'border-top':    `${MARKER_WIDTH_PX / 2}px solid transparent`,
        'border-bottom': `${MARKER_WIDTH_PX / 2}px solid transparent`,
        'border-left':   `${this.type === "arrow_right" ? MARKER_WIDTH_PX : 0}px solid ${this.color}`,
        'border-right':  `${this.type === "arrow_left" ? MARKER_WIDTH_PX : 0}px solid ${this.color}`,
      }
    }
  }

  // #endregion Properties

}

</script>